import { gql } from '@apollo/client';

export const getTemplatesQuery = gql`
    query GetTemplates {
        templateCategories(data: { archived: false }) {
            id
            name
            description
            translations {
                language
                name
                description
                externalDescription
            }
            icon
            iconColor
            progressColor
            customIcon
            externalLink
            externalDescription
            system
            goal {
                id
                name
                l1CurrencyReward
                l1Target
                l2CurrencyReward
                l2Target
                l3CurrencyReward
                l3Target
            }
            quests {
                id
                name
                description
                translations {
                    language
                    name
                    description
                }
                difficulty
                repeat {
                    interval
                    repeatingType
                    startHour
                    startMinute
                    query
                    weekDays
                    monthDays
                }
                timedInterval
                timerValueInMs
                external
                externalDeepLink
                timing
                templateGoalId
                achievementIds
            }
            achievements {
                id
                name
                description
                translations {
                    language
                    name
                    description
                    achievementLevels {
                        name
                        description
                    }
                }
                rarity
                icon
                iconImageColor
                iconImageUrl
                iconImageUrlNotAchieved
                questIds
                achievementConditions {
                    questIds
                    target
                    value
                    metricType
                }
            }
        }
    }
`;
